// extracted by mini-css-extract-plugin
module.exports = {"table":"DataTable_table__8auL_"};